import SuiBox from "components/SuiBox";
import Alert from "custom/Alert";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import UserDetails from "../components/user-details";

const NewUser = ({ redirectTo }) => {
  const history = useHistory();

  useEffect(() => {
    if (redirectTo && redirectTo !== "" && redirectTo !== "/user/new") {
      history.push(redirectTo);
    }
  }, [redirectTo]);

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox mt={3} mb={8}>
          <UserDetails />
        </SuiBox>
      </DashboardLayout>
    </>
  );
};
NewUser.defaultProps = {
  redirectTo: "",
};

NewUser.propTypes = {
  redirectTo: PropTypes.string,
};

const mapStateToProps = (state) => ({
  redirectTo: state.ui.redirectTo,
});

export default connect(mapStateToProps, null)(NewUser);
